










































import Vue, {VueConstructor} from "vue";
import {ValidationObserver} from "vee-validate";

export default (Vue as VueConstructor<
    Vue & {
  $refs: {
    obs: InstanceType<typeof ValidationObserver>;
  };
}
  >).extend({
  data() {
    return {
      dialog: false
    }
  },
  components: {
    ValidationObserver
  },
  props: {
    title: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    value: {
      type: Boolean,
      required: true
    },
    showClose: {
      type: Boolean,
      required: false,
      default: () => {
        return false
      }
    }
  },
  methods: {
    handleCancel: function () {
      this.dialog = false
      this.$emit('cancel')
    },
    save: async function () {
      const isValid = await this.$refs.obs.validate()
      this.$emit('submit', isValid)
    }
  },
  created () {
    this.dialog = this.value
  },
  watch: {
    value: function () {
      this.dialog = this.value
    },
    dialog: function () {
      this.$emit('input', this.dialog)
      this.$refs.obs.reset()
    }
  }
})

